import React from 'react';
import Breadcumb from '../../components/Breadcumb'
import InfoComponent from '../../components/InfoComponent'
import FeaturesList from './FeaturesList'
import ImageBox from './ImageBox'
import CardSection from './CardSection'

const ConnectWalletContainer = () => {

  return (
    <>
		<Breadcumb  
		          namePage='Wallet Connect'
		          title='Wallet Connect'
		/>
		<section className="features section-padding-100 ">

			<div className="container">
				<InfoComponent
				  	titleSm='Connect Your Wallet'
				  	titleLg='Connect Wallet'
				  	text='Connect Your Wallet.'
				/>
			  
				<div className="row">

					<FeaturesList />

					<ImageBox />
				  
				</div>
			</div>
		</section>
		<CardSection />
    </>
  );
}

export default ConnectWalletContainer;